export const ADMIN = {
  loginCard: 'admin-login-card',
  emailInput: 'admin-email-input',
  passwordInput: 'admin-password-input',
  loginSubmit: 'admin-login-submit-button',
  loginError: 'admin-login-error',
  logoutButton: 'admin-logout-button',
  dashboardContainer: 'analytics-dashboard-container',
  timeframeSelect: 'timeframe-filter-select',
  releaseFilterSelect: 'release-filter-select',
  trafficChart: 'traffic-trend-chart',
  completionCard: 'completion-rate-card',
  avgDurationCard: 'avg-duration-card',
  uniqueVisitorsCard: 'unique-visitors-card',
  topCountriesTable: 'top-countries-table',
  topCitiesTable: 'top-cities-table',
  outboundChart: 'outbound-clicks-chart',
  outboundReleaseFilter: 'outbound-release-filter',
  trackBreakdownTable: 'track-breakdown-table',
  trackRowHighSkip: 'track-row-high-skip',
  liveListenerCounter: 'live-listener-counter',
  liveListenerReleaseFilter: 'live-listener-release-filter',
  releaseTable: 'release-crud-table',
  addReleaseButton: 'add-new-release-button',
  editReleaseButtonPrefix: 'edit-release-button',
  deleteReleaseButtonPrefix: 'delete-release-button',
  releaseEditorModal: 'release-editor-modal',
  releaseTitleInput: 'release-title-input',
  releaseArtistInput: 'release-artist-input',
  releaseSlugInput: 'release-slug-input',
  sleepControlsToggle: 'sleep-controls-toggle',
  saveReleaseButton: 'save-release-button',
  generateArtButton: 'generate-art-button',
  statusSelect: 'release-status-select',
  tabOverview: 'admin-tab-overview',
  tabReleases: 'admin-tab-releases',
};
